import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { Store } from 'components/common/types/Store.types';
import { isDirectSalesCampaignCloned } from 'components/pages/Planner/hooks/utils/isDirectSalesCampaignCloned';
import { getDealId } from 'store/dealManagement/selectors/getDealId';
import { DirectSalesReportTypeButtonsProps, ReportTypeButton } from './ReportTypeButtons.types';
import { ReportType } from '../AllocationReport.types';
import { ReportTypeButtons } from './ReportTypeButtons';

export const DirectSalesReportTypeButtons: React.FC<DirectSalesReportTypeButtonsProps> = ({
  activeReportType,
  handleFetchDirectSalesAllocationReport,
  selectedLine,
}) => {
  const campaignId = useSelector(getDealId);
  const originalLineStatuses = useSelector((state: Store) => state.dealManagement.meta?.originalLineStatuses ?? {});

  const isCampaignCloned = isDirectSalesCampaignCloned(campaignId);
  const isLineWithSavedAllocation = Object.keys(originalLineStatuses).includes(selectedLine.lineId);
  const showExistingSavedAllocationButton = isCampaignCloned && isLineWithSavedAllocation;

  const reportTypeButtons: ReportTypeButton[] = useMemo(
    () => [
      {
        id: 'allocation',
        isActive:
          !showExistingSavedAllocationButton ||
          (showExistingSavedAllocationButton && activeReportType === ReportType.NOT_SAVED),
        isOnClickEnabled: showExistingSavedAllocationButton && activeReportType !== ReportType.NOT_SAVED,
        isVisible: showExistingSavedAllocationButton,
        label: 'Allocation',
        onClick: () =>
          handleFetchDirectSalesAllocationReport(
            showExistingSavedAllocationButton ? ReportType.NOT_SAVED : ReportType.SAVED,
          ),
      },
      {
        id: 'existing-allocation',
        isActive: activeReportType === ReportType.SAVED,
        isOnClickEnabled: activeReportType !== ReportType.SAVED,
        isVisible: showExistingSavedAllocationButton,
        label: 'Existing Saved Allocation',
        onClick: () => handleFetchDirectSalesAllocationReport(ReportType.SAVED),
      },
    ],
    [activeReportType, showExistingSavedAllocationButton, selectedLine],
  );

  return <ReportTypeButtons reportTypeButtons={reportTypeButtons} />;
};
